"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gradient = void 0;
var type_guard_1 = require("@webnuts/type-guard");
// https://developer.mozilla.org/en-US/docs/Web/CSS/gradient
var GRADIENT = type_guard_1.props({
    function: type_guard_1.enums([
        'linear-gradient',
        'radial-gradient',
        'conic-gradient',
        'repeating-linear-gradient',
        'repeating-radial-gradient'
    ]),
    args: type_guard_1.string()
});
exports.gradient = type_guard_1.union([GRADIENT, type_guard_1.array({ length: { min: 1 }, items: GRADIENT })]);
